"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPermissionsState = void 0;
const streem_logger_1 = require("./streem_logger");
const getPermissionsState = () => __awaiter(void 0, void 0, void 0, function* () {
    // The permissions we can query:
    // https://developer.mozilla.org/en-US/docs/Web/API/Permissions/query#name
    // Firefox does not support querying by 'camera' or 'microphone' so this will not work.
    let camera = undefined;
    let microphone = undefined;
    try {
        // @ts-ignore 'camera' is not a valid permission name because it's not supported in Firefox
        camera = yield navigator.permissions.query({ name: 'camera' });
    }
    catch (e) {
        if (e instanceof Error)
            streem_logger_1.streemLogger.info('Unable to determine permissions for camera: ', e.message);
    }
    try {
        microphone = yield navigator.permissions.query({
            // @ts-ignore 'microphone' is not a valid permission name because it's not supported in Firefox
            name: 'microphone',
        });
    }
    catch (e) {
        if (e instanceof Error)
            streem_logger_1.streemLogger.info('Unable to determine permissions for microphone: ', e.message);
    }
    return {
        camera: camera === null || camera === void 0 ? void 0 : camera.state,
        microphone: microphone === null || microphone === void 0 ? void 0 : microphone.state,
    };
});
exports.getPermissionsState = getPermissionsState;
//# sourceMappingURL=permission_state.js.map